import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable(
  { providedIn: 'root' }
)
export class BreadcrumbService {

  private readonly isLoadingSubject = new BehaviorSubject<boolean>(false);
  readonly isLoading$ = this.isLoadingSubject.asObservable();

  params: Map<string, string> = new Map();
  paramSet$ = new Subject<string>();

  constructor(private activatedRoute: ActivatedRoute,
    router: Router) {

    router.events.subscribe((val) => {
      this.isLoadingSubject.next(false);
    });
  }

  public setIsLoading(isLoading: boolean) {
    setTimeout(() => {
      this.isLoadingSubject.next(isLoading);
    });
  }

  public setParam(paramName: string, paramValue: string | null | undefined) {
    if (paramName.startsWith(':')) paramName = paramName.substring(1);

    if (!paramValue) {
      this.params.delete(paramName);
    }
    else {
      this.params.set(paramName, paramValue);
    }

    this.paramSet$.next(paramName);
  }

  public clearParams() {
    this.params.clear();
  }

  public replaceParamsWithValues(text: string) {
    let params = this.findRouteParams(text);
    params?.forEach(param => {
      let paramValue = this.getParam(param);
      text = text.replace(param, paramValue);
    });
    return text;
  }

  public getParam(paramName: string) {
    if (paramName.startsWith(':')) paramName = paramName.substring(1);

    let paramValue = this.params.get(paramName);
    if (!paramValue) {
      paramValue = this.getParamFromRoute(paramName);
    }

    return paramValue;
  }

  private getParamFromRoute(param: string): string {
    let paramName = param;
    if (paramName.startsWith(':')) paramName = paramName.substring(1);

    let paramValue = this.recursivelyGetParamFromChildRoutes(paramName, this.activatedRoute);
    return paramValue;
  }

  private recursivelyGetParamFromChildRoutes(paramName: string, activatedRoute: ActivatedRoute): string {
    let paramValue = activatedRoute.snapshot.paramMap.get(paramName) ?? '';
    if (paramValue) return paramValue;

    for (let i = 0; i < activatedRoute.children.length; i++) {
      const childRoute = activatedRoute.children[i];
      paramValue = childRoute.snapshot.paramMap.get(paramName) ?? '';

      if (!paramValue) {
        paramValue = this.recursivelyGetParamFromChildRoutes(paramName, childRoute);
      }

      if (paramValue) return paramValue;
    }

    return '';
  }

  private findRouteParams(text: string) {
    if (!text) return;

    let regexp = /:\w+/g;
    return text.match(regexp);
  }
}
